var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23C16 19.134 19.134 16 23 16H47C50.866 16 54 19.134 54 23V41C54 44.866 50.866 48 47 48H23C19.134 48 16 44.866 16 41V23Z",
    fill: "#3F936A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 0C29.701 0 25 4.70101 25 10.5V16H29V10.5C29 6.91015 31.9101 4 35.5 4C39.0899 4 42 6.91015 42 10.5V16H46V10.5C46 4.70101 41.299 0 35.5 0Z",
    fill: "#4B81AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 32.6632C38.1825 32.1015 39 30.8962 39 29.5C39 27.567 37.433 26 35.5 26C33.567 26 32 27.567 32 29.5C32 30.8962 32.8175 32.1015 34 32.6632V37.5C34 38.3284 34.6716 39 35.5 39C36.3284 39 37 38.3284 37 37.5V32.6632Z",
    fill: "#2A5B43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49981 65.33C4.02152 65.0539 3.85765 64.4423 4.13379 63.964L5.26778 61.9999H3C2.44772 61.9999 2 61.5521 2 60.9999C2 60.4476 2.44772 59.9999 3 59.9999H5.26771L4.13379 58.0359C3.85765 57.5576 4.02152 56.946 4.49981 56.6698C4.97811 56.3937 5.5897 56.5576 5.86584 57.0359L6.9998 58.9999L8.13379 57.0358C8.40993 56.5575 9.02153 56.3936 9.49982 56.6698C9.97811 56.9459 10.142 57.5575 9.86584 58.0358L8.73189 59.9999H11C11.5523 59.9999 12 60.4476 12 60.9999C12 61.5521 11.5523 61.9999 11 61.9999H8.73182L9.86584 63.964C10.142 64.4423 9.97811 65.0539 9.49982 65.3301C9.02153 65.6062 8.40993 65.4423 8.13379 64.964L6.9998 62.9999L5.86584 64.964C5.5897 65.4423 4.97811 65.6061 4.49981 65.33Z",
    fill: "#093E62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4998 65.33C23.0215 65.0539 22.8576 64.4423 23.1338 63.964L24.2678 61.9999H22C21.4477 61.9999 21 61.5521 21 60.9999C21 60.4476 21.4477 59.9999 22 59.9999H24.2677L23.1338 58.0359C22.8576 57.5576 23.0215 56.946 23.4998 56.6698C23.9781 56.3937 24.5897 56.5576 24.8658 57.0359L25.9998 58.9999L27.1338 57.0358C27.4099 56.5575 28.0215 56.3936 28.4998 56.6698C28.9781 56.9459 29.142 57.5575 28.8658 58.0358L27.7319 59.9999H30C30.5523 59.9999 31 60.4476 31 60.9999C31 61.5521 30.5523 61.9999 30 61.9999H27.7318L28.8658 63.964C29.142 64.4423 28.9781 65.0539 28.4998 65.3301C28.0215 65.6062 27.4099 65.4423 27.1338 64.964L25.9998 62.9999L24.8658 64.964C24.5897 65.4423 23.9781 65.6061 23.4998 65.33Z",
    fill: "#093E62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4998 65.33C42.0215 65.0539 41.8576 64.4423 42.1338 63.964L43.2678 61.9999H41C40.4477 61.9999 40 61.5521 40 60.9999C40 60.4476 40.4477 59.9999 41 59.9999H43.2677L42.1338 58.0359C41.8576 57.5576 42.0215 56.946 42.4998 56.6698C42.9781 56.3937 43.5897 56.5576 43.8658 57.0359L44.9998 58.9999L46.1338 57.0358C46.4099 56.5575 47.0215 56.3936 47.4998 56.6698C47.9781 56.9459 48.142 57.5575 47.8658 58.0358L46.7319 59.9999H49C49.5523 59.9999 50 60.4476 50 60.9999C50 61.5521 49.5523 61.9999 49 61.9999H46.7318L47.8658 63.964C48.142 64.4423 47.9781 65.0539 47.4998 65.3301C47.0215 65.6062 46.4099 65.4423 46.1338 64.964L44.9998 62.9999L43.8658 64.964C43.5897 65.4423 42.9781 65.6061 42.4998 65.33Z",
    fill: "#093E62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4998 65.33C61.0215 65.0539 60.8576 64.4423 61.1338 63.964L62.2678 61.9999H60C59.4477 61.9999 59 61.5521 59 60.9999C59 60.4476 59.4477 59.9999 60 59.9999H62.2677L61.1338 58.0359C60.8576 57.5576 61.0215 56.946 61.4998 56.6698C61.9781 56.3937 62.5897 56.5576 62.8658 57.0359L63.9998 58.9999L65.1338 57.0358C65.4099 56.5575 66.0215 56.3936 66.4998 56.6698C66.9781 56.9459 67.142 57.5575 66.8658 58.0358L65.7319 59.9999H68C68.5523 59.9999 69 60.4476 69 60.9999C69 61.5521 68.5523 61.9999 68 61.9999H65.7318L66.8658 63.964C67.142 64.4423 66.9781 65.0539 66.4998 65.3301C66.0215 65.6062 65.4099 65.4423 65.1338 64.964L63.9998 62.9999L62.8658 64.964C62.5897 65.4423 61.9781 65.6061 61.4998 65.33Z",
    fill: "#093E62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 69,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2874B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPassword);
export default __webpack_public_path__ + "static/media/imgPassword.9327dcea06236d622b6f589b5525ac39.svg";
export { ForwardRef as ReactComponent };